import { DeleteDocumentParams } from './../../work-order/work-order-edit/work-order-default-edit/work-order-documents/work-order-documents.service';
import { AfterViewInit, ChangeDetectorRef, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { CtBinaryOperator, CtDatatableActionCustomConfiguration, CtExportConfiguration, CtModelConfiguration, CTModelDatatableFilter, CtModelOperator, MAT_RAISED_PRIMARY } from '@ctsolution/ct-framework';
import { CTMGeneralService } from '../../../_core/lib/general.service';
import { LeadRouteData } from '../../../_core/route-data/lead.route-data';
import { DEFAULT_DATATABLE_CONFIGURATION } from '../../../_core/constants';
import { StateLeadBulletConfiguration } from './state-lead-bullet/state-lead-bullet.configuration';
import { ActivatedRoute } from '@angular/router';
import { FileGet } from '../../../_core/classes/file-get';
import { FileService } from '../../../_core/lib/file.service';
import { ReportDownloadParameter } from '../../../_core/classes/report-download.parameter';
import { WorkOrderService } from '../../work-order/work-order.service';
import { CompanyType } from '../../../_core/enum/company-type';
import { TranslateService } from '@ngx-translate/core';
import { WorkOrderRowsExportTypeVO } from '../../lang-download-file/lang-download-file.configuration';
import { DataRequest, MethodEnum } from "@ctsolution/ct-webapi";
import { CtManagerService } from '../../../_core/lib/ct-manager.service';
import { CTConfigurationModel } from '../../../_core/classes/ct-configuration-model';


@Component({
  selector: 'app-lead-list',
  templateUrl: './lead-list.component.html',
  styleUrls: ['./lead-list.component.scss'],
  providers: [WorkOrderService]
})
export class LeadListComponent implements AfterViewInit {

  @Input() configuration: CtModelConfiguration<LeadListComponent> | null = null;
  @Input() importComponent = false;

  @ViewChild("downloadButtons") downloadButtons: TemplateRef<any> | null = null;
  @ViewChild('StateCellTemplate') stateCellTemplate: TemplateRef<any> | null = null;

  datatableConfiguration = DEFAULT_DATATABLE_CONFIGURATION();

  // Variabili per tracciare il tipo di Lead (Business o Private)
  private isLeadCompany: boolean = false;
  private isLeadPrivate: boolean = false;

  // Configurazione per controllare la visibilità dell'export
  leadExportConfiguration: CTConfigurationModel = CTConfigurationModel.create();

  constructor(
    private general: CTMGeneralService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private fileService: FileService,
    private workOrderService: WorkOrderService,
    private translateService: TranslateService,
    private managerService: CtManagerService) {
  }

  ngAfterViewInit() {

  if (this.importComponent) {
    this.setup();
    return;
  }

  this.route
    .queryParams
    .subscribe(params => {

      const q = params['q'];
      let title = "CT_PAGE.BREADCRUMBS.DetailLead";
      // Reset delle variabili di classe prima del controllo
      this.isLeadCompany = false;
      this.isLeadPrivate = false;

      if (q) {

        const filterValues = JSON.parse(q);

        filterValues.constants.forEach((constant: any) => {

          const value = constant.Value[0];

          const filter = CTModelDatatableFilter
            .create()
            .setField('[LeadSourceType] is null OR [LeadSourceType.CompanyType.Type] = ?')
            .setValue([+value])
            .setOperatorType(CtBinaryOperator.OrOperator)

          // Inizializza la configurazione se non esiste
          if (!this.configuration) {
            this.configuration = this.defaultSetup();
          }

          this.configuration?.fieldsCustomTemplates?.push({
            prop: 'LeadSource',
            filters: [filter],
          })

          if (+value === CompanyType.Business) {

            this.isLeadCompany = true;
            title = "CT_PAGE.BREADCRUMBS.DetailLeadBusiness"


            //Soluzione momentanea perché i filtri non mi prendevano l'etichetta corretta se sostituivo i fields, cosi l'inglese non funziona.

          } else if (+value === CompanyType.Private) {

            this.isLeadPrivate = true;
            title = "CT_PAGE.BREADCRUMBS.DetailLeadPrivate";

          }

        });

        if (this.isLeadCompany && this.configuration) {
          const customFieldsRequest = new DataRequest()
            .setController([LeadRouteData().controller!])
            .setMethod(MethodEnum.GET)
            .setAction('Fields')
            .setQueryParams({
              configurationCode: 'LeadCompany'
            });

          this.configuration.setGetFieldsDataRequest(customFieldsRequest);
        } else if (this.isLeadPrivate && this.configuration) {

          const customFieldsRequest = new DataRequest()
            .setController([LeadRouteData().controller!])
            .setMethod(MethodEnum.GET)
            .setAction('Fields')
            .setQueryParams({
              configurationCode: 'LeadPrivate'
            });

          this.configuration.setGetFieldsDataRequest(customFieldsRequest);
        }

      }

      this.route
        .data
        .subscribe(data => {
          data['title'] = title;
        })

      setTimeout(() => {
        this.setup();
      }, 0);

    });

}

  async setup() {

    if (!this.configuration) {
      this.configuration = this.defaultSetup();
    }

    // ✅ Recupera la configurazione override per lead
    await this.managerService.getComponentOverride("lead", "leadExportConfiguration", this.leadExportConfiguration).then((component) => {
      return;
    });

    this.datatableConfiguration
      .setCustomDatatableActionConfiguration(
        CtDatatableActionCustomConfiguration
          .create()
          .setTemplateOutlet(this.downloadButtons))
          .setDeleteActionEnabled(true)


    this.configuration
      .setFieldsCustomTemplates([
        {
          prop: 'LeadStatus',
          cellTemplate: this.stateCellTemplate,
          filterOptions: {
            multiple: true,
          } as any
        },
      ])
      .setCTDatatableConfiguration(this.datatableConfiguration);

    // ✅ Configurazione Export basata sul tipo di Lead
    // Controlla se è un Lead Business o Private e configura l'export appropriato
    // SOLO se leadExportConfiguration.exportExcelEnabled è true
    if (this.leadExportConfiguration.exportExcelEnabled) {

      if (this.isLeadCompany) {
        // Export per Lead Business
        this.configuration
          .setOperations([
            CtModelOperator.Delete,
            CtModelOperator.Export
          ])
          .setExportConfiguration(
            CtExportConfiguration
              .create()
              // Action backend per Lead Business
              .setAction('ExportExcel_Lead_Business')
              // Label bottone export
              .setLabel('Esporta')
              // Icona bottone
              .setIcon('download')
              // Nome file per il download (senza estensione)
              .setFileName('Export_Opportunità')
              // Colore bottone blu
              .setMaterialOptions(MAT_RAISED_PRIMARY)
              // Esporta tutti i record ignorando la paginazione
              .setIncludePagination(false)
          );
      } else if (this.isLeadPrivate) {
        // Export per Lead Private
        this.configuration
          .setOperations([
            CtModelOperator.Delete,
            CtModelOperator.Export
          ])
          .setExportConfiguration(
            CtExportConfiguration
              .create()
              // Action backend per Lead Private
              .setAction('ExportExcel_Lead_Private')
              // Label bottone export
              .setLabel('Esporta')
              // Icona bottone
              .setIcon('download')
              // Nome file per il download (senza estensione)
              .setFileName('Export_Candidati')
              // Colore bottone blu
              .setMaterialOptions(MAT_RAISED_PRIMARY)
              // Esporta tutti i record ignorando la paginazione
              .setIncludePagination(false)
          );
      }

    }

  }

  defaultSetup() {

    return CtModelConfiguration
      .create<LeadListComponent>()
      .setRouteData(LeadRouteData())
      .setDefaultActionsEnabled(true)
      .setOnCreate(() => this.general.navigateOnCTModelRouter(["lead"], "create", { qpHandling: 'preserve' }))
      .setOnEdit(event => this.general.navigateOnCTModelRouter(["lead"], "edit", {
        value: event,
        configuration: this.configuration,
        qpHandling: 'preserve'
      }))
      .setOperations([CtModelOperator.Delete])
      .setOnDelete()

  }

  stateBulletConfiguration = (state: string) => StateLeadBulletConfiguration.create(state)

  onZipDownload(event: any) {

    if (event.Files.length > 0) {
      this.downloadZip(event.Files[0].Endpoint, event.Name)
    }

    //siamo d'accordo con le api che il primo elemento sia sempre lo zip, altrimenti si avrà un type per definirlo

  }

  private downloadZip(endpoint: string, leadname: string) {

    const filename = `Documenti_Lead_${leadname}`;

    const value: FileGet = {
      Endpoint: endpoint
    };

    this.fileService.downloadAttachmentByEndPoint(value, filename)

    //TODO: potrà essere personalizzata l'etichetta in base alle esigenze
  }

  private downloadPdf(value?: { Oid: number | null }, lang?: any) {

    if (!value?.Oid) return;

    const parameter: ReportDownloadParameter = ReportDownloadParameter
      .create()
      .setLeadOid(value.Oid)
      .setTemplateLanguage(lang?.code ?? 'it')
      .setRowType(lang?.rowType ?? WorkOrderRowsExportTypeVO.All)
      .setDirectDownload(false)
      .setOpenInBrowser(true)
      .setAction('LeadPdf')
      .setLabelDownload(`Lead${value.Oid}`);

    this.workOrderService.downloadWorkOrderPDF(parameter);

  }

  leadHasDocumentsAvailable = (value: any) => (value?.Files ?? []).length;

  triggerMenu(value: any) {

    const leadHasDocumentsAvailable = this.leadHasDocumentsAvailable(value);

    if (leadHasDocumentsAvailable) return;

    this.downloadPdf(value);

  }

}
